import { api } from "../../../config/axios/interceptor";

export async function getAllMedicines(searchKey) {
  try {
    // encodeURIComponent so names with & + etc. survive the URL (otherwise
    // '&' splits the query string and '+' is decoded as a space).
    const response = await api.get(
      `medicine_master?search=${encodeURIComponent(searchKey || "")}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllTemplates(searchKey) {
  try {
    const response = await api.get(
      `prescription-templates?search=${searchKey}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addMedicines(medicines) {
  try {
    const response = await api.post(`medicine_master`, medicines);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function editMedicinesDate(medicine, id) {
  try {
    const response = await api.put(`medicine_master/` + id, medicine);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteMedicine(id) {
  try {
    const response = await api.delete(`medicine_master/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteMedicineTemplate(id) {
  try {
    const response = await api.delete(`prescription-templates/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function createTemplate(payload) {
  try {
    const response = await api.post(`prescription-templates`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function editTemplate(payload, id) {
  try {
    const response = await api.put(`prescription-templates/` + id, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMedDetails({ search }) {
  try {
    // encodeURIComponent so special-char names (& + etc.) resolve correctly,
    // so the med-bill name->item lookup works and stock displays.
    const response = await api.get(
      `/inv_item_master?search=${encodeURIComponent(search || "")}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getBatchDetails({ id }) {
  try {
    const response = await api.get(`/inv_item_stock?item_id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllBatchDetails({ id }) {
  try {
    const response = await api.get(`/inv_item_stock`);
    return response;
  } catch (error) {
    throw error;
  }
}
